import {
  ROUTE_CLAIM_SPOT,
  ROUTE_CONFIRM_PAYOUT_EMAIL,
  ROUTE_CREATE_GAME_ORDER,
  ROUTE_CREATE_GAME_BET_ORDER,
  ROUTE_CREATE_MEMBERSHIP_ORDER,
  ROUTE_CREATE_ORDER,
  ROUTE_DELETE_ACCOUNT,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_TEXT_CLUB,
  ROUTE_FULL_SIGNUP,
  ROUTE_GAME_LANDING_REDIRECT,
  ROUTE_GAME_REDIRECT,
  ROUTE_GLP_WON_JOIN,
  ROUTE_GLP_WON_LOGIN,
  ROUTE_GLP_WON_PAY,
  ROUTE_GLP_WON_SIGNUP,
  ROUTE_GLP_WON_SMS_CONSENT,
  ROUTE_GLP_WON_SUCCESS,
  ROUTE_GAME_SETTINGS,
  ROUTE_GAME_HOST_FEED,
  ROUTE_INVITE_GLP_WON_LANDING,
  ROUTE_INVITE_LANDING,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_MEMBERSHIP_SIGNUP,
  ROUTE_OPTIONAL_BET,
  ROUTE_PHONE_NUMBER,
  ROUTE_REFERRAL_SIGNUP,
  ROUTE_RESET_PASSWORD,
  ROUTE_ROUTINES_CAMPAIGN,
  ROUTE_SIGNUP,
  ROUTE_ACCOUNTABILITY_PARTNER_INVITE_LANDING,
} from '#src/store/location/actions';

import * as claimSpot from './claim-spot';
import * as completePayoutRequest from './complete-payout-request';
import * as createGameBetOrder from './createGameBetOrder';
import * as createGameOrder from './createGameOrder';
import * as createOrder from './create-order';
import * as createMembershipOrder from './createMembershipOrder';
import * as deleteAccount from './delete-account';
import * as textClub from './text-club';
import * as fullSignup from './full-signup';
import * as gameLandingRedirect from './game-landing-redirect';
import * as gameRedirect from './game-redirect';
import * as gameHostFeed from './game-host-feed';
import * as gameSettings from './game-settings';
import * as glpWonJoin from './glp-won-join';
import * as glpWonLogin from './glp-won-login';
import * as glpWonPay from './glp-won-pay';
import * as glpWonSignup from './glp-won-signup';
import * as glpWonSmsConsent from './glp-won-sms-consent';
import * as glpWonSuccess from './glp-won-success';
import * as inviteAccountabilityLanding from './invite-accountability-landing';
import * as inviteGlpWonLanding from './invite-glp-won-landing';
import * as inviteLanding from './invite-landing';
import * as login from './login';
import * as logout from './logout';
import * as membershipSignup from './membership-signup';
import * as optionalBet from './optionalBet';
import * as phoneNumber from './phone-number';
import * as referralSignup from './referral-signup';
import * as routinesCampaign from './routines-campaign';
import * as signup from './signup';

const buildPageTitle = (name) =>
  name
    ? `WayBetter - ${name} - Get healthier playing games`
    : `WayBetter - Get healthier playing games`;

export function generateStaticRoutes({ ctx, graphqlClient } = {}) {
  const routes = {
    [ROUTE_CLAIM_SPOT]: {
      path: claimSpot.path,
      component: claimSpot.component,
      thunk: claimSpot.thunk(),
      name: 'Claim Your Spot',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_CONFIRM_PAYOUT_EMAIL]: {
      path: completePayoutRequest.path,
      component: completePayoutRequest.component,
      thunk: completePayoutRequest.thunk(graphqlClient),
      name: 'Complete Payout Request',
      pageTitle: buildPageTitle('Payout'),
    },
    [ROUTE_CREATE_GAME_BET_ORDER]: {
      path: createGameBetOrder.path,
      component: createGameBetOrder.component,
      thunk: createGameBetOrder.thunk(),
      name: 'Create Game Bet Order',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_CREATE_GAME_ORDER]: {
      path: createGameOrder.path,
      component: createGameOrder.component,
      thunk: createGameOrder.thunk(),
      name: 'Create Game Order',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_CREATE_ORDER]: {
      path: createOrder.path,
      component: createOrder.component,
      thunk: createOrder.thunk(),
      name: 'Create Order',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_CREATE_MEMBERSHIP_ORDER]: {
      path: createMembershipOrder.path,
      component: createMembershipOrder.component,
      thunk: createMembershipOrder.thunk(),
      name: 'Create Membership Order',
      pageTitle: buildPageTitle('Membership'),
    },
    [ROUTE_DELETE_ACCOUNT]: {
      path: deleteAccount.path,
      component: deleteAccount.component,
      name: 'Delete Account',
      thunk: deleteAccount.thunk(),
      pageTitle: buildPageTitle(),
    },
    [ROUTE_FORGOT_PASSWORD]: {
      path: '/login/forgot-password',
      component: 'ForgotPassword',
      name: 'Forgot Password',
      pageTitle: buildPageTitle('Forgot Password'),
    },
    [ROUTE_TEXT_CLUB]: {
      path: textClub.path,
      component: textClub.component,
      thunk: textClub.thunk({ ctx, graphqlClient }),
      name: 'Text Club',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_FULL_SIGNUP]: {
      path: fullSignup.path,
      component: fullSignup.component,
      thunk: fullSignup.thunk(),
      name: 'Full Signup',
      pageTitle: buildPageTitle('Signup'),
    },
    [ROUTE_GAME_LANDING_REDIRECT]: {
      path: gameLandingRedirect.path,
      component: gameLandingRedirect.component,
      thunk: gameLandingRedirect.thunk({ graphqlClient }),
      name: 'Game Landing',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GAME_REDIRECT]: {
      path: gameRedirect.path,
      component: gameRedirect.component,
      thunk: gameRedirect.thunk(),
      name: 'Game',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GAME_SETTINGS]: {
      path: gameSettings.path,
      component: gameSettings.component,
      thunk: gameSettings.thunk({ graphqlClient }),
      name: 'Game Settings',
      pageTitle: buildPageTitle('Game Settings'),
    },
    [ROUTE_GAME_HOST_FEED]: {
      path: gameHostFeed.path,
      component: gameHostFeed.component,
      thunk: gameHostFeed.thunk({ ctx, graphqlClient }),
      name: 'Game Host Feed',
      pageTitle: buildPageTitle('Game Feed'),
    },
    [ROUTE_GLP_WON_JOIN]: {
      path: glpWonJoin.path,
      component: glpWonJoin.component,
      thunk: glpWonJoin.thunk({ ctx }),
      name: 'GLP Won Join',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GLP_WON_LOGIN]: {
      path: glpWonLogin.path,
      component: glpWonLogin.component,
      thunk: glpWonLogin.thunk(),
      name: 'GLP Won Login',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GLP_WON_PAY]: {
      path: glpWonPay.path,
      component: glpWonPay.component,
      thunk: glpWonPay.thunk({ ctx }),
      name: 'GLP Won Payment',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GLP_WON_SIGNUP]: {
      path: glpWonSignup.path,
      component: glpWonSignup.component,
      thunk: glpWonSignup.thunk(),
      name: 'GLP Won Signup',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_GLP_WON_SMS_CONSENT]: {
      path: glpWonSmsConsent.path,
      component: glpWonSmsConsent.component,
      name: 'GLP Won SMS Consent',
      pageTitle: buildPageTitle('GLP Won SMS Consent'),
    },
    [ROUTE_GLP_WON_SUCCESS]: {
      path: glpWonSuccess.path,
      component: glpWonSuccess.component,
      thunk: glpWonSuccess.thunk({ ctx }),
      name: 'GLP Won Success',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_ACCOUNTABILITY_PARTNER_INVITE_LANDING]: {
      path: inviteAccountabilityLanding.path,
      component: inviteAccountabilityLanding.component,
      thunk: inviteAccountabilityLanding.thunk({ graphqlClient }),
      name: 'Invite Landing for Accountability Partner',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_INVITE_LANDING]: {
      path: inviteLanding.path,
      component: inviteLanding.component,
      thunk: inviteLanding.thunk({ ctx, graphqlClient }),
      name: 'Invite Landing',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_INVITE_GLP_WON_LANDING]: {
      path: inviteGlpWonLanding.path,
      component: inviteGlpWonLanding.component,
      thunk: inviteGlpWonLanding.thunk({ ctx, graphqlClient }),
      name: 'Invite Landing',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_LOGIN]: {
      path: login.path,
      component: login.component,
      thunk: login.thunk(),
      name: 'Login',
      pageTitle: buildPageTitle('Login'),
    },
    [ROUTE_LOGOUT]: {
      path: logout.path,
      component: logout.component,
      thunk: logout.thunk({ ctx, graphqlClient }),
      name: 'Logout',
      pageTitle: buildPageTitle('Logout'),
    },
    [ROUTE_MEMBERSHIP_SIGNUP]: {
      path: membershipSignup.path,
      component: membershipSignup.component,
      thunk: membershipSignup.thunk({ ctx, graphqlClient }),
      name: 'Membership Signup',
      pageTitle: buildPageTitle('Signup'),
    },
    [ROUTE_OPTIONAL_BET]: {
      path: optionalBet.path,
      component: optionalBet.component,
      thunk: optionalBet.thunk(),
      name: 'Optional Bet',
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_PHONE_NUMBER]: {
      path: phoneNumber.path,
      component: phoneNumber.component,
      name: 'Phone Number',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Game'),
    },
    [ROUTE_REFERRAL_SIGNUP]: {
      path: referralSignup.path,
      component: referralSignup.component,
      thunk: referralSignup.thunk({ graphqlClient }),
      name: 'Referral Signup',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle('Signup'),
    },
    [ROUTE_RESET_PASSWORD]: {
      path: '/login/reset-password',
      component: 'ResetPassword',
      name: 'Reset Password',
      pageTitle: buildPageTitle('Reset Password'),
    },
    [ROUTE_ROUTINES_CAMPAIGN]: {
      path: routinesCampaign.path,
      component: routinesCampaign.component,
      thunk: routinesCampaign.thunk({ graphqlClient }),
      name: 'Routines Campaign Landing',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
      pageTitle: buildPageTitle(),
    },
    [ROUTE_SIGNUP]: {
      path: signup.path,
      component: signup.component,
      thunk: signup.thunk(),
      name: 'Signup',
      pageTitle: buildPageTitle('Signup'),
    },
  };

  return routes;
}
